export default __webpack_public_path__ + "static/media/rating.896fedb1.png";